import request from "./request";
/**
 *分页查询用户信息
 * @param userId 用户id
 * @param userName 用户名称
 * @param type 1-管理员2-普通用户
 */
export default async function getUserPage(params = {}) {
  const defaultParams = {
    pageNumber: 1,
    pageSize: 10,
  };
  return await request.get("/spin/sysUser/getUserPage", {
    params: { ...defaultParams, ...params },
  });
}
